import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SelectStringGroupComponent extends Component {
  constructor () {
    super()

    this.state = {
      value: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  getChildContext () {
    const { name, selectedValue, onChange } = this.props
    return {
      selectGroup: {
        name, selectedValue, onChange
      }
    }
  }

  handleChange (event) {
    event.preventDefault()
    this.setState({ value: event.target.value }, () => {
      this.props.onChange(this.state.value, this.props.name)
    })
  }

  componentWillMount () {
    this.setState({ value: this.props.selectedValue })
  }

  render () {
    const { name, label, children } = this.props
    return (
      <div className='clearfix'>
        <label className='form__label' htmlFor={name} >{label}</label>
        <div className='form__input__select form__select__string__input'>
          <select style={{border: 'none'}} name={name} value={this.state.value} onChange={this.handleChange}>
            {children}
          </select>
        </div>
      </div>
    )
  }
}

const { string, func, oneOfType, node, object } = PropTypes
SelectStringGroupComponent.propTypes = {
  name: string,
  selectedValue: string,
  onChange: func,
  children: node.isRequired,
  Component: oneOfType([
    string,
    func,
    object
  ])
}

SelectStringGroupComponent.defaultProps = {
  Component: 'div'
}

SelectStringGroupComponent.childContextTypes = {
  selectGroup: PropTypes.object
}

export const SelectStringGroup = SelectStringGroupComponent



// WEBPACK FOOTER //
// ./src/components/ui/inputs/SelectStringGroup.js